export enum TransactionType{
    REGULAR = 1,
    FREESPIN = 10,
    RESPIN = 30,
    RESPIN_IN_FREESPIN = 31
}